export default __webpack_public_path__ + "static/media/birth-plan-01.01ec5b7f.png";